var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finalizado"},[_c('h1',[_vm._v("Anexos enviados com sucesso")]),_c('p',[_vm._v("Entraremos em contato em breve.")])])}]

export { render, staticRenderFns }